import { Box, Flex, SimpleGrid, Text, Select, HStack, useBreakpointValue } from "@chakra-ui/react";
import NewImg from "@/assets/images/creator_img3.png";
import EchartsComponent, {
  MyChartOptions,
} from "@/components/echartsComponent";
import WorksDataItem from "@/components/creatorcenter/worksdataitem";
import { WorkInfo } from "@/types/creatorcenter";

const CreatorDataCenter = () => {
  const column = useBreakpointValue({
    base: 2, // 屏幕宽度小于40em（640px）时的值
    sm: 2,   // 屏幕宽度在40em-52em（640px-853px）之间时的值
    md: 3,   // 屏幕宽度在52em-64em（853px-1024px）之间时的值
    lg: 5,   // 屏幕宽度在64em-80em（1024px-1280px）之间时的值
    xl: 7,  // 屏幕宽度在80em-100em（1280px-1920px）之间时的值
  })
  
  // 图表配置项
  const totalDatalineOption: MyChartOptions = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
      },
      padding: [5, 10],
    },
    // legend: {
    //   data: ['销量'],
    // },
    xAxis: {
      data: ["04/07", "04/07", "04/07", "04/07", "04/07", "04/07"],
      show: true,
      boundaryGap: false,
      axisLabel: {
        interval: 0, // 强制显示所有标签
        showMaxLabel: true,
        margin: 10,
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      axisLabel: {
        // 使用 formatter 函数来格式化标签文本
        formatter: "{value} 人", // 这里的 '{value} 人' 就是标签加上了单位 "人"
        margin: 20, // 设置刻度标签距离轴的距离为20
      },
      axisTick: {
        show: false,
      },
    },
    grid: {
      left: 0,
      right: 30,
      bottom: 0,
      top: 10,
      containLabel: true, // 是否包含坐标轴的标签
    },
    series: [
      {
        name: "观看量",
        type: "line",
        // smooth: true,
        data: [1, 244, 699, 10, 107, 20],
        animationDuration: 2800,
        animationEasing: "cubicInOut",
      },
      {
        name: "评论数",
        type: "line",
        // smooth: true,
        data: [188, 628, 166, 1000, 107, 450],
        animationDuration: 2800,
        animationEasing: "cubicInOut",
      },
      {
        name: "点赞量",
        type: "line",
        // smooth: true,
        data: [14, 208, 360, 100, 10, 20],
        animationDuration: 2800,
        animationEasing: "cubicInOut",
      },
      {
        name: "分享数",
        type: "line",
        // smooth: true,
        data: [1, 2, 377, 109, 614, 21],
        animationDuration: 2800,
        animationEasing: "cubicInOut",
      },
      {
        name: "涨粉数",
        type: "line",
        // smooth: true,
        data: [1, 20, 386, 190, 10, 20],
        animationDuration: 2800,
        animationEasing: "cubicInOut",
      },
      {
        name: "被同款数",
        type: "line",
        // smooth: true,
        data: [1, 312, 514, 10, 150, 12],
        animationDuration: 2800,
        animationEasing: "cubicInOut",
      },
    ],
  };

  const WorkInfoList: WorkInfo[] = [
    {
      id: "mw555zq4ujrgtj1189uxuwkika",
      intro: "梦幻空间 彩色 水母",
      image_url: `${NewImg}`,
      like_num: 2341,
      collect_num: 1,
      page_view: 1,
      onekey_nums: 18,
      share_num: 1,
      comment_num: 1000,
      fans_num: 1,
      publish_time: "2024-08-09",
      // 图表配置项
      lineOption: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          padding: [5, 10],
        },
        // legend: {
        //   data: ['销量'],
        // },
        xAxis: {
          data: ["04/07", "04/07", "04/07", "04/07", "04/07", "04/07"],
          show: true,
          boundaryGap: false,
          axisLabel: {
            interval: 0, // 强制显示所有标签
            showMaxLabel: true,
            margin: 10,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          axisLabel: {
            // 使用 formatter 函数来格式化标签文本
            formatter: "{value} 人", // 这里的 '{value} 人' 就是标签加上了单位 "人"
            margin: 20, // 设置刻度标签距离轴的距离为20
          },
          axisTick: {
            show: false,
          },
        },
        grid: {
          left: 0,
          right: 30,
          bottom: 0,
          top: 10,
          containLabel: true, // 是否包含坐标轴的标签
        },
        series: [
          {
            name: "观看量",
            type: "line",
            // smooth: true,
            data: [1, 244, 699, 10, 107, 20],
            animationDuration: 2800,
            animationEasing: "cubicInOut",
          },
          {
            name: "评论数",
            type: "line",
            // smooth: true,
            data: [188, 628, 166, 1000, 107, 450],
            animationDuration: 2800,
            animationEasing: "cubicInOut",
          },
          {
            name: "点赞量",
            type: "line",
            // smooth: true,
            data: [14, 208, 360, 100, 10, 20],
            animationDuration: 2800,
            animationEasing: "cubicInOut",
          },
          {
            name: "分享数",
            type: "line",
            // smooth: true,
            data: [1, 2, 377, 109, 614, 21],
            animationDuration: 2800,
            animationEasing: "cubicInOut",
          },
          {
            name: "涨粉数",
            type: "line",
            // smooth: true,
            data: [1, 20, 386, 190, 10, 20],
            animationDuration: 2800,
            animationEasing: "cubicInOut",
          },
          {
            name: "被同款数",
            type: "line",
            // smooth: true,
            data: [1, 312, 514, 10, 150, 12],
            animationDuration: 2800,
            animationEasing: "cubicInOut",
          },
        ],
      },
    },
  ];

  return (
    <Box h="100%" pl="20px" pr="20px" overflow={"auto"}>
      <Box borderWidth="1px" borderColor={"#DCE0EB"} p="20px" mt="20px">
        <Flex mb="20px" justifyContent={"space-between"}>
          <Box fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
            数据总览
          </Box>
          <Flex alignItems={"center"}>
            <Text fontSize={"12px"} color={"#8E94A9"}>
              筛选条件:{" "}
            </Text>
            <Select
              color={"#27314D"}
              fontSize={"12px"}
              w="80px"
              border={"none"}
              size="xs"
              placeholder="请选择"
            >
              <option>近7日</option>
            </Select>
          </Flex>
        </Flex>
        <SimpleGrid columns={column} spacing={"20px"}>
          <Box p="10px 20px" bgColor={"rgba(238, 241, 247, 0.5)"}>
            <Box color={"#8E94A9"} fontSize="14px">
              新增粉丝数
            </Box>
            <Box color={"#333C58"} fontSize="28px" fontFamily="Allerta">
              1
            </Box>
          </Box>
          <Box p="10px 20px" bgColor={"rgba(238, 241, 247, 0.5)"}>
            <Box color={"#8E94A9"} fontSize="14px">
              主页访客
            </Box>
            <Box color={"#333C58"} fontSize="28px" fontFamily="Allerta">
              0
            </Box>
          </Box>
          <Box p="10px 20px" bgColor={"rgba(238, 241, 247, 0.5)"}>
            <Box color={"#8E94A9"} fontSize="14px">
              观看数
            </Box>
            <Box color={"#333C58"} fontSize="28px" fontFamily="Allerta">
              451
            </Box>
          </Box>
          <Box p="10px 20px" bgColor={"rgba(238, 241, 247, 0.5)"}>
            <Box color={"#8E94A9"} fontSize="14px">
              被同款数
            </Box>
            <Box color={"#333C58"} fontSize="28px" fontFamily="Allerta">
              10
            </Box>
          </Box>
          <Box p="10px 20px" bgColor={"rgba(238, 241, 247, 0.5)"}>
            <Box color={"#8E94A9"} fontSize="14px">
              互动数
            </Box>
            <Box color={"#333C58"} fontSize="28px" fontFamily="Allerta">
              1218
            </Box>
          </Box>
          <Box p="10px 20px" bgColor={"rgba(238, 241, 247, 0.5)"}>
            <Box color={"#8E94A9"} fontSize="14px">
              点赞数
            </Box>
            <Box color={"#333C58"} fontSize="28px" fontFamily="Allerta">
              18
            </Box>
          </Box>
          <Box p="10px 20px" bgColor={"rgba(238, 241, 247, 0.5)"}>
            <Box color={"#8E94A9"} fontSize="14px">
              收藏数
            </Box>
            <Box color={"#333C58"} fontSize="28px" fontFamily="Allerta">
              12
            </Box>
          </Box>
        </SimpleGrid>
        <Flex mt={"40px"} mb="20px">
          <Box fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
            数据趋势
          </Box>
        </Flex>
        <Box h="240px">
          <EchartsComponent chartsOption={totalDatalineOption} />
        </Box>
      </Box>

      <Box borderWidth="1px" borderColor={"#DCE0EB"} p="20px" mt="20px">
        <Flex mb="20px" justifyContent={"space-between"}>
          <Box fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
            最新发布创作数据
          </Box>
          <HStack>
            <Flex alignItems={"center"}>
              <Text fontSize={"12px"} color={"#8E94A9"}>
                类型:
              </Text>
              <Select
                color={"#27314D"}
                fontSize={"12px"}
                w="80px"
                border={"none"}
                size="xs"
              >
                <option>全部</option>
              </Select>
            </Flex>
            <Flex alignItems={"center"}>
              <Text fontSize={"12px"} color={"#8E94A9"}>
                筛选条件:
              </Text>
              <Select
                color={"#27314D"}
                fontSize={"12px"}
                w="80px"
                border={"none"}
                size="xs"
              >
                <option>近7日</option>
              </Select>
            </Flex>
          </HStack>
        </Flex>
        {WorkInfoList.map((item) => {
          return (
            <Box key={item.id} mb="20px">
              <WorksDataItem workInfo = {item} />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default CreatorDataCenter;
